import { options } from "../formatter-options";
import { truncateSelectedValues, formatSelectionsArray } from "./utils";
export const getFormattedStoreLocations = (storeSelections = [])=>truncateSelectedValues(formatSelectionsArray(storeSelections, options.storeData));
